import { React, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import {
  Stack,
  CircularProgress,
  Modal,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { ToastContainer, toast } from "react-toastify";
import nodata from "assets/images/nodata.png";
import MDBadge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ListIcon from "@mui/icons-material/List";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PrintIcon from "@mui/icons-material/Print";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import VoucherDialog from "views/pages/student_dashboard/Pages/VoucherDialog";
const BASE_URL = process.env.REACT_APP_BASE_URL;
import { hasAdmissionPermission } from "hooks/permissions";
import {
  canAccessApplicantImpersonationUI,
  buildImpersonationBackup,
  setImpersonationBackup,
  removeImpersonationBackup,
  applyAuthSessionToStorage,
  notifyImpersonationChanged,
  impersonateApplicant,
} from "utils/impersonationAccess";

const APPLICATION_TYPE_OPTIONS = [
  { value: "Undergraduate", label: "Undergraduate (BS)" },
  { value: "Undergraduate-5", label: "Undergraduate (BS 5th Semester)" },
  { value: "Postgraduate", label: "Postgraduate (M.Phil after 4-year BS)" },
  { value: "Postgraduate-5", label: "Postgraduate (M.Phil after BA/B.Sc & MA/M.Sc)" },
  { value: "PH.D", label: "Ph.D (after 4-year BS)" },
  { value: "Phd-5", label: "Ph.D (after BA/B.Sc & MA/M.Sc)" },
];

const formatApplicationType = (type) => {
  const match = APPLICATION_TYPE_OPTIONS.find((option) => option.value === type);
  return match ? match.label : type || "-";
};

const formatLogData = (value) => {
  if (!value) return "-";
  return typeof value === "object" ? JSON.stringify(value, null, 2) : value;
};

function SearchApplications() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const canImpersonate = canAccessApplicantImpersonationUI(token);
  const [impersonatingUserId, setImpersonatingUserId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [logsModal, setLogsModal] = useState(false);
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [selectedApplicationId, setSelectedApplicationId] = useState(null);
  const [vouchersModal, setVouchersModal] = useState(false);
  const [vouchersLoading, setVouchersLoading] = useState(false);
  const [applicationVouchers, setApplicationVouchers] = useState([]);
  const [voucherModal, setVoucherModal] = useState(false);
  const [admissionVoucher, setAdmissionVoucher] = useState({});
  const [printingVoucherCode, setPrintingVoucherCode] = useState(null);
  const [typeModal, setTypeModal] = useState(false);
  const [selectedAppForType, setSelectedAppForType] = useState(null);
  const [newApplicationType, setNewApplicationType] = useState("");
  const [updatingType, setUpdatingType] = useState(false);
  const canChangeApplicationType =
    hasAdmissionPermission("Search Applications", "UPDATE") ||
    hasAdmissionPermission("Search Applications", "MANAGE");

  const formatVoucherType = (type) => {
    const labels = {
      "admission-application": "Processing Fee",
      "admission-voucher": "Admission Fee",
      "semester-fee-morning": "Semester Fee (Morning)",
      "semester-fee-evening": "Semester Fee (Evening)",
    };
    return labels[type] || type || "-";
  };

  const formatDisplayDate = (value) => {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return String(value).split(" ")[0] || value;
    }
    return parsed.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const isProcessingVoucher = (voucherType) => voucherType === "admission-application";

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Application ID", accessor: "id", align: "center" },
    { Header: "Applicant Name", accessor: "name", align: "center" },
    { Header: "Father Name", accessor: "father_name", align: "center" },
    { Header: "Step", accessor: "step", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Application Type", accessor: "application_type", align: "center" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Phone", accessor: "phone", align: "center" },
    { Header: "CNIC", accessor: "applicant_cnic", align: "center" },
    { Header: "Created At", accessor: "created_at", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const handleView = (id) => {
    window.open(`/admissions/view-admission-form/${id}`);
  };

  const handleLoginAsApplicant = async (userId) => {
    if (!userId) {
      toast.error("Applicant user ID not found for this application");
      return;
    }
    setImpersonatingUserId(userId);
    const backup = buildImpersonationBackup();
    setImpersonationBackup(backup);
    try {
      const data = await impersonateApplicant(userId);
      applyAuthSessionToStorage(data);
      notifyImpersonationChanged();
      toast.success("Opened applicant account in impersonation mode");
      navigate("/student-dashboard");
    } catch (error) {
      removeImpersonationBackup();
      toast.error(error.message || "Failed to impersonate applicant");
    } finally {
      setImpersonatingUserId(null);
    }
  };

  const handleViewLogs = async (applicationId) => {
    setSelectedApplicationId(applicationId);
    setLogsModal(true);
    setLogsLoading(true);
    setLogs([]);
    
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(`${BASE_URL}/submit_application/get_application_logs/${applicationId}`, requestOptions);
      const result = await response.json();
      
      if (response.ok) {
        setLogs(result.logs || []);
        if ((result.logs || []).length === 0) {
          toast.info("No logs found for this application");
        }
      } else {
        toast.error(result.error || "Failed to fetch logs");
      }
    } catch (error) {
      toast.error("An error occurred while fetching logs");
    } finally {
      setLogsLoading(false);
    }
  };

  const handleCloseLogsModal = () => {
    setLogsModal(false);
    setLogs([]);
    setSelectedApplicationId(null);
  };

  const handleCloseVouchersModal = () => {
    setVouchersModal(false);
    setApplicationVouchers([]);
    setSelectedApplicationId(null);
  };

  const handleCloseVoucherPrintModal = () => {
    setVoucherModal(false);
    setAdmissionVoucher({});
  };

  const handleOpenTypeModal = (app) => {
    setSelectedAppForType(app);
    setNewApplicationType(app.application_type || "");
    setTypeModal(true);
  };

  const handleCloseTypeModal = () => {
    if (updatingType) return;
    setTypeModal(false);
    setSelectedAppForType(null);
    setNewApplicationType("");
  };

  const handleUpdateApplicationType = async () => {
    if (!selectedAppForType?.id) {
      toast.error("Application not found");
      return;
    }
    if (!newApplicationType) {
      toast.error("Please select an application type");
      return;
    }
    if (newApplicationType === selectedAppForType.application_type) {
      toast.error("Application already has this type");
      return;
    }

    setUpdatingType(true);
    try {
      const response = await fetch(`${BASE_URL}/application/update_application_type`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          application_id: selectedAppForType.id,
          application_type: newApplicationType,
        }),
      });
      const result = await response.json();
      if (response.ok) {
        setResults((prev) =>
          prev.map((app) =>
            app.id === selectedAppForType.id
              ? { ...app, application_type: newApplicationType }
              : app
          )
        );
        toast.success(result.success || "Application type updated successfully");
        setTypeModal(false);
        setSelectedAppForType(null);
        setNewApplicationType("");
      } else {
        toast.error(result.error || "Failed to update application type");
      }
    } catch (error) {
      toast.error("An error occurred while updating application type");
    } finally {
      setUpdatingType(false);
    }
  };

  const handleViewVouchers = async (applicationId) => {
    setSelectedApplicationId(applicationId);
    setVouchersModal(true);
    setVouchersLoading(true);
    setApplicationVouchers([]);

    try {
      const response = await fetch(
        `${BASE_URL}/fee_voucher/get_vouchers_by_application/${applicationId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (response.ok) {
        setApplicationVouchers(result.vouchers || []);
        if ((result.vouchers || []).length === 0) {
          toast.info("No vouchers found for this application");
        }
      } else {
        toast.error(result.error || "Failed to fetch vouchers");
      }
    } catch (error) {
      toast.error("An error occurred while fetching vouchers");
    } finally {
      setVouchersLoading(false);
    }
  };

  const fetchProcessingVoucherForPrint = async (voucherCode) => {
    const response = await fetch(
      `${BASE_URL}/fee_voucher/get_voucher_by_code_for_print/${voucherCode}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to load voucher for print");
    }
    const data = await response.json();
    return data.admission_voucher;
  };

  const handlePrintVoucher = async (voucher) => {
    if (!voucher?.voucher_code) {
      toast.error("Voucher code not found");
      return;
    }

    setPrintingVoucherCode(voucher.voucher_code);
    try {
      if (isProcessingVoucher(voucher.voucher_type)) {
        const printData = await fetchProcessingVoucherForPrint(voucher.voucher_code);
        setAdmissionVoucher(printData);
        setVoucherModal(true);
      } else if (voucher.url_token) {
        window.open(`/admissions/fee-voucher/${voucher.url_token}`, "_blank");
      } else {
        toast.error("Print URL not available for this voucher");
      }
    } catch (error) {
      toast.error(error.message || "Failed to print voucher");
    } finally {
      setPrintingVoucherCode(null);
    }
  };

  const rows = results.length > 0
    ? results.map((app, index) => ({
        serial: index + 1,
        id: app.id,
        name: app.name,
        father_name: app.father_name,
        step: app.step || "-",
        status: app.is_completed === 1 ? (
          <MDBox ml={-1}>
            <MDBadge badgeContent="Completed" color="success" variant="gradient" size="sm" />
          </MDBox>
        ) : (
          <MDBox ml={-1}>
            <MDBadge badgeContent="Incomplete" color="warning" variant="gradient" size="sm" />
          </MDBox>
        ),
        application_type: formatApplicationType(app.application_type),
        email: app.email,
        phone: app.phone,
        applicant_cnic: app.applicant_cnic,
        created_at: (
          <>
            {hasAdmissionPermission("Search Applications", "MANAGE") &&
            app.createdAt ? new Date(app.createdAt).toLocaleString() : "-"}
          </>
        ),
        actions: (
          <>
            {hasAdmissionPermission("Search Applications", "READ") && (
              <IconButton onClick={() => handleView(app.id)}>
                <VisibilityIcon style={{ color: "blue" }} />
              </IconButton>
            )}
            <IconButton onClick={() => handleViewLogs(app.id)}>
              <ListIcon style={{ color: "green" }} />
            </IconButton>
            {canChangeApplicationType && (
              <Tooltip title="Change application type">
                <IconButton onClick={() => handleOpenTypeModal(app)}>
                  <SwapHorizIcon style={{ color: "#1A73E8" }} />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="View vouchers">
              <IconButton onClick={() => handleViewVouchers(app.id)}>
                <ReceiptLongIcon style={{ color: "purple" }} />
              </IconButton>
            </Tooltip>
            {canImpersonate && app.user_id && (
              <Tooltip title="Login as applicant">
                <span>
                  <IconButton
                    onClick={() => handleLoginAsApplicant(app.user_id)}
                    disabled={impersonatingUserId === app.user_id}
                  >
                    {impersonatingUserId === app.user_id ? (
                      <CircularProgress size={20} />
                    ) : (
                      <SwitchAccountIcon style={{ color: "orange" }} />
                    )}
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </>
        ),
      }))
    : [];

  const handleFetch = async () => {
    if (!searchTerm.trim()) {
      toast.error("Please enter a search term");
      return;
    }
    setLoading(true);
    setResults([]);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ search: searchTerm.trim() }),
      };
      const response = await fetch(BASE_URL + "/application/search_application_forms", requestOptions);
      const result = await response.json();
      if (response.ok) {
        setResults(result.results || []);
        if ((result.results || []).length === 0) {
          toast.info("No applications found");
        }
      } else {
        toast.error(result.error || "Failed to fetch applications");
      }
    } catch (error) {
      toast.error("An error occurred while searching");
    } finally {
      setLoading(false);
    }
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '800px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflow: 'auto',
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="mb-4">
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Search Applications
                </MDTypography>
                <MDTypography variant="caption" color="text" mb={2}>
                  You can search by Form No.,Email, Phone, Name, Father Name, or CNIC with dashes.
                </MDTypography>
                <Stack direction="row" spacing={2} alignItems="center" mt={2}>
                  <Paper component="form" onSubmit={e => { e.preventDefault(); handleFetch(); }} sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}>
                    <InputBase
                      sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                      placeholder="Enter search term"
                      inputProps={{ "aria-label": "search applications" }}
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </Paper>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFetch}
                    disabled={loading}
                    style={{ color: "white" }}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Fetch"}
                  </Button>
                </Stack>
              </MDBox>
            </Card>
            <Card>
              <MDBox pt={3} pb={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <CircularProgress />
                  </MDBox>
                ) : results.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox display="flex" flexDirection="column" alignItems="center" p={5}>
                    <img
                      src={nodata}
                      style={{ width: "20%", height: "20%" }}
                      alt="No Data"
                    />
                    <MDTypography variant="body1" mt={2}>
                      No applications found. Please try a different search term.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Logs Modal */}
      <Modal
        open={logsModal}
        onClose={handleCloseLogsModal}
        aria-labelledby="logs-modal-title"
        aria-describedby="logs-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="logs-modal-title" variant="h6" component="h2" mb={2}>
            Application Logs - ID: {selectedApplicationId}
          </Typography>
          
          {logsLoading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : logs.length > 0 ? (
            <Box>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f0f0f0' }}>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Sr.No</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Application ID</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>User ID</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Email</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Message</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Previous Data</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>New Data</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{index + 1}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{log.application_form || '-'}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{log.user_id || '-'}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{log.email || '-'}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>{log.message || '-'}</td>
                      <td style={{ border: '1px solid #ddd', padding: '8px', maxWidth: '200px', wordWrap: 'break-word' }}>
                        {(log.previous_data || log.previous_data) ? (
                          <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap', margin: 0 }}>
                            {formatLogData(log.previous_data || log.previous_data)}
                          </pre>
                        ) : '-'}
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px', maxWidth: '200px', wordWrap: 'break-word' }}>
                        {(log.new_data || log.new_data) ? (
                          <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap', margin: 0 }}>
                            {formatLogData(log.new_data || log.new_data)}
                          </pre>
                        ) : '-'}
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        {log.created_at ? new Date(log.created_at).toLocaleString() : 
                         log.updated_at ? new Date(log.updated_at).toLocaleString() : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          ) : (
            <Typography variant="body1" textAlign="center" p={3}>
              No logs found for this application.
            </Typography>
          )}
          
          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleCloseLogsModal}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Vouchers Modal */}
      <Modal
        open={vouchersModal}
        onClose={handleCloseVouchersModal}
        aria-labelledby="vouchers-modal-title"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "92%",
            maxWidth: "960px",
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            padding: "24px",
            maxHeight: "85vh",
            overflow: "auto",
            borderRadius: "8px",
          }}
        >
          <Typography id="vouchers-modal-title" variant="h6" component="h2" style={{ marginBottom: "16px" }}>
            Application Vouchers - ID: {selectedApplicationId}
          </Typography>

          {vouchersLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
              <CircularProgress />
            </div>
          ) : applicationVouchers.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginBottom: "20px",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5" }}>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", fontWeight: 600, width: "6%" }}>Sr.No</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "left", fontSize: "13px", fontWeight: 600, width: "14%" }}>Voucher Code</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "left", fontSize: "13px", fontWeight: 600, width: "18%" }}>Type</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "right", fontSize: "13px", fontWeight: 600, width: "10%" }}>Amount</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", fontWeight: 600, width: "12%" }}>Due Date</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", fontWeight: 600, width: "12%" }}>Status</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", fontWeight: 600, width: "14%" }}>Payment Date</th>
                    <th style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", fontWeight: 600, width: "8%" }}>Print</th>
                  </tr>
                </thead>
                <tbody>
                  {applicationVouchers.map((voucher, index) => (
                    <tr key={voucher.id || index} style={{ backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff" }}>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", fontSize: "13px", verticalAlign: "middle" }}>{index + 1}</td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", wordBreak: "break-word" }}>{voucher.voucher_code || "-"}</td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", wordBreak: "break-word" }}>{formatVoucherType(voucher.voucher_type)}</td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", textAlign: "right" }}>{voucher.amount || "-"}</td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", textAlign: "center" }}>{formatDisplayDate(voucher.due_date)}</td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", textAlign: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#fff",
                            backgroundColor: voucher.is_paid === 1 ? "#2e7d32" : "#ed6c02",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {voucher.is_paid === 1 ? "Paid" : "Not Paid"}
                        </span>
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", fontSize: "13px", verticalAlign: "middle", textAlign: "center" }}>
                        {formatDisplayDate(voucher.payment_date)}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "10px 8px", textAlign: "center", verticalAlign: "middle" }}>
                        <Tooltip title="Print voucher">
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => handlePrintVoucher(voucher)}
                              disabled={printingVoucherCode === voucher.voucher_code}
                            >
                              {printingVoucherCode === voucher.voucher_code ? (
                                <CircularProgress size={18} />
                              ) : (
                                <PrintIcon fontSize="small" />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <Typography variant="body1" style={{ textAlign: "center", padding: "24px" }}>
              No vouchers found for this application.
            </Typography>
          )}

          <div style={{ marginTop: "16px", display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={handleCloseVouchersModal}
              style={{ color: "#fff", backgroundColor: "#28166F", textTransform: "none", fontWeight: 600 }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>

      <VoucherDialog
        voucherModal={voucherModal}
        handleCloseVoucherModal={handleCloseVoucherPrintModal}
        admissionVoucher={admissionVoucher}
      />

      <Dialog open={typeModal} onClose={handleCloseTypeModal} maxWidth="sm" fullWidth>
        <DialogTitle>Change Application Type</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1, mt: 1 }}>
            Application ID: <strong>{selectedAppForType?.id || "-"}</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Current Type:{" "}
            <strong>{formatApplicationType(selectedAppForType?.application_type)}</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            New Application Type
          </Typography>
          <select
            value={newApplicationType}
            onChange={(e) => setNewApplicationType(e.target.value)}
            disabled={updatingType}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="">Select application type</option>
            {APPLICATION_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2 }}>
            This change is recorded in Application Logs. Program preferences may need correction
            if they no longer match the new type.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTypeModal} disabled={updatingType}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdateApplicationType}
            disabled={updatingType}
            style={{ color: "#fff", backgroundColor: "#28166F", textTransform: "none" }}
          >
            {updatingType ? <CircularProgress size={20} color="inherit" /> : "Update Type"}
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default SearchApplications;